module.exports = __webpack_public_path__ + "static/img/defalut_img.6fbdeee2.png";